import { types } from "./types";
import ConvertDateToString from "./ConvertDateToString/ConvertDateToString";
import ConvertDateToTimestamp from "./ConvertDateToTimestamp/ConvertDateToTimestamp";
import ModifyDate from "./ModifyDate/ModifyDate";

function Actions(
  action,
  variables,
  setOpenVariable,
  variableRender,
  visible
) {
  switch (action.actionName) {
    case types.CONVERTDATETOSTRING:
      return (
        <ConvertDateToString
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.MODIFYDATE:
      return (
        <ModifyDate
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          visible={visible}
        />
      );
    case types.CONVERTDATETOTIMESTAMP:
      return (
        <ConvertDateToTimestamp
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    default: break;
  }
}

export default Actions;
